// extracted by mini-css-extract-plugin
module.exports = {"outer":"WhiteBox_outer__24V3a","pixels":"WhiteBox_pixels__2lpQv","inner":"WhiteBox_inner__NYkhj"};